<template>
  <footer>
    <div class="w-full flex flex-col md:flex-row py-6">
      <div class="w-full md:w-2/6 mx-4">
        <nuxt-link class="flex text-orange-600 no-underline hover:no-underline font-bold text-2xl lg:text-4xl" to="/#">
          <img :src="logo" alt="Abbes Weinladen" class="object-cover w-10/12 self-center" />
        </nuxt-link>
        <div class="mt-6">
          <p>Ringstraße 10 A (Ecke Dürerstraße)</p>
          <p>12203 Berlin Steglitz Zehlendorf</p>
          <br />
          <p>Telefon: +49 (0)30 / 833 12 29</p>
          <p>
            E-Mail:
            <a href="mailto:abbes.weinladen@web.de">abbes.weinladen@web.de</a>
          </p>
        </div>
      </div>

      <div class="w-full md:w-4/6 mx-4">
        <p class="uppercase text-gray-500 mt-4 md:mt-0 md:mb-6">Links</p>
        <ul class="list-reset mb-6">
          <li class="mt-2 block">
            <nuxt-link class="no-underline hover:underline text-gray-800 hover:text-orange-500" to="/l/willkommen"
              >Über uns</nuxt-link
            >
          </li>
          <li class="mt-2 block">
            <nuxt-link class="no-underline hover:underline text-gray-800 hover:text-orange-500" to="/l/veranstaltungen"
              >Veranstaltungen</nuxt-link
            >
          </li>
          <li class="mt-2 block">
            <nuxt-link class="no-underline hover:underline text-gray-800 hover:text-orange-500" to="/l/wein-des-monats"
              >Wein des Monats</nuxt-link
            >
          </li>
          <li class="mt-2 block">
            <nuxt-link class="no-underline hover:underline text-gray-800 hover:text-orange-500" to="/l/neue-weine"
              >Neue Weine</nuxt-link
            >
          </li>
          <li class="mt-2 block">
            <nuxt-link class="no-underline hover:underline text-gray-800 hover:text-orange-500" to="/wissen"
              >Weinwissen</nuxt-link
            >
          </li>
          <li class="mt-2 block">
            <nuxt-link
              class="no-underline hover:underline text-gray-800 hover:text-orange-500"
              to="/l/prima-probier-paket"
              >Prima Probier-Paket</nuxt-link
            >
          </li>
          <li class="mt-2 block">
            <nuxt-link class="no-underline hover:underline text-gray-800 hover:text-orange-500" to="/impressum"
              >Impressum</nuxt-link
            >
          </li>
          <li class="mt-2 block">
            <nuxt-link class="no-underline hover:underline text-gray-800 hover:text-orange-500" to="/datenschutz">
              Datenschutz
            </nuxt-link>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import logo from '@/assets/img/logo.png'

export default {
  data() {
    return {
      logo,
    }
  },
}
</script>
